// extracted by mini-css-extract-plugin
export var box = "_94-1";
export var checkboxRow = "_94-8";
export var checked = "_94-2";
export var descriptionSpacer = "_94-a";
export var disabled = "_94-3";
export var icon = "_94-6";
export var input = "_94-0";
export var labelSpacer = "_94-9";
export var medium = "_94-5";
export var small = "_94-4";
export var text = "_94-7";